import { render } from "./DocumentsGrid.vue?vue&type=template&id=53393398&scoped=true&ts=true"
import script from "./DocumentsGrid.vue?vue&type=script&lang=ts"
export * from "./DocumentsGrid.vue?vue&type=script&lang=ts"

import "./DocumentsGrid.vue?vue&type=style&index=0&id=53393398&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53393398"]])

export default __exports__